(function () {
  const STORAGE_KEY = 'bundle_builder_from_product';

  let pickerState = {
    root: null,
    quantity: 0,
    selected: [],
    filter: 'all',
    products: [],
    bound: false,
  };

  function getRoutes() {
    return window.routes && typeof window.routes === 'object' ? window.routes : {};
  }

  function getAddUrl() {
    return getRoutes().cart_add_url || '/cart/add.js';
  }

  function getCheckoutUrl() {
    return getRoutes().checkout_url || '/checkout';
  }

  function parseJsonScript(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.warn('[Badass Qty Offers] Invalid config JSON', err);
      return null;
    }
  }

  function getConfig(root) {
    return parseJsonScript(root.querySelector('[data-qty-offers-config]')) || {};
  }

  function getOffersRoot(fromEl) {
    return fromEl && fromEl.closest ? fromEl.closest('[data-badass-qty-offers]') : null;
  }

  function getSelectedVariantId(root) {
    const scope = root.closest('product-info, .product') || document;
    const form = scope.querySelector('form[data-type="add-to-cart-form"]');
    const input = form ? form.querySelector('[name="id"]') : null;
    if (input && input.value) return String(input.value);
    return String(root.getAttribute('data-variant-id') || '');
  }

  function getProductId(root) {
    const config = getConfig(root);
    if (config.productId) return String(config.productId);
    return String(root.getAttribute('data-product-id') || '');
  }

  function getProductTitle(root) {
    const config = getConfig(root);
    if (config.productTitle) return String(config.productTitle);
    const row = root.querySelector('[data-title]');
    if (row && row.getAttribute('data-title')) return String(row.getAttribute('data-title'));
    const label = root.querySelector('.hsh-pdp-product-label');
    if (label && label.textContent) return label.textContent.trim();
    return '';
  }

  function tierForQuantity(qty, discount, discountCode) {
    if (discountCode) return String(discountCode);
    if (discount != null && discount !== '') return 'BUY' + String(qty) + '-' + String(discount);
    return 'BUY' + String(qty);
  }

  function formatMoney(cents, moneyFormat) {
    const amount = (Number(cents) || 0) / 100;
    const formatted = amount.toFixed(2);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, moneyFormat || '${{amount}}');
      } catch (err) {
        /* fall through */
      }
    }
    const format = moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(amount)))
      .replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  function buildBundleUrl(bundlePageUrl, payload) {
    const url = new URL(bundlePageUrl, window.location.origin);
    if (payload.productId) url.searchParams.set('product_id', payload.productId);
    if (payload.variantId) url.searchParams.set('variant_id', payload.variantId);
    if (payload.quantity) url.searchParams.set('quantity', String(payload.quantity));
    if (payload.tier) url.searchParams.set('tier', payload.tier);
    if (payload.discount != null) url.searchParams.set('discount', String(payload.discount));
    if (payload.pickDifferentScents) url.searchParams.set('pick_different', '1');
    return url.pathname + url.search;
  }

  function storeBundleIntent(payload) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({ ts: Date.now() }, payload)));
    } catch (err) {
      /* ignore */
    }
  }

  function setTileLoading(tile, loading) {
    if (!tile) return;
    tile.classList.toggle('is-loading', !!loading);
    tile.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function showError(root, message) {
    const errorEl = root.querySelector('[data-qty-offers-error]');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function getCartSectionsPayload(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return null;
    try {
      return cart.getSectionsToRender().map((section) => section.id);
    } catch (err) {
      return null;
    }
  }

  function refreshCartUi(response) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function') return;
    try {
      if (typeof cart.setActiveElement === 'function' && document.activeElement) {
        cart.setActiveElement(document.activeElement);
      }
      cart.renderContents(response, { openDrawer: false });
      if (typeof cart.close === 'function') {
        cart.close();
        window.setTimeout(() => cart.close(), 50);
      }
    } catch (err) {
      console.warn('[Badass Qty Offers] Cart UI refresh failed', err);
    }
  }

  function notifyCartAdded(response, variantId, options) {
    const opts = options || {};
    const payload = {
      source: 'product-qty-offers',
      productVariantId: variantId,
      cartData: response,
      skipCartAddedModal: opts.skipCartAddedModal === true,
      bundleLabel: opts.bundleLabel || null,
    };

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, payload);
    }

    document.dispatchEvent(new CustomEvent('cart:update', { detail: payload }));
    if (!opts.skipCartAddedModal) refreshCartUi(response);
  }

  function buildSameScentCartBody(config, quantity, productTitle) {
    const bundleVariants = config.bundleVariants || {};
    const bundleVariantId = bundleVariants[String(quantity)];
    if (!bundleVariantId) return null;

    const bundleLabels = config.bundleLabels || {};
    const props = {
      Bundle: 'Custom Bundle',
      'Bundle Size': String(quantity),
      'Bundle Label': bundleLabels[String(quantity)] || 'BadAss ' + quantity + '-Candle Bundle',
    };

    for (let i = 1; i < quantity + 1; i += 1) {
      props['Scent ' + i] = productTitle;
    }

    return {
      items: [{ id: parseInt(bundleVariantId, 10), quantity: 1, properties: props }],
    };
  }

  function buildMixedScentCartBody(config, quantity, scents) {
    /* Buy 1: add the chosen scent SKU directly (no pack shell required). */
    if (Number(quantity) === 1) {
      const scent = scents && scents[0];
      const scentVariantId = scent && (scent.variant_id || scent.variantId);
      if (!scentVariantId) return null;
      return {
        items: [{ id: parseInt(scentVariantId, 10), quantity: 1 }],
      };
    }

    const bundleVariants = config.bundleVariants || {};
    const bundleVariantId = bundleVariants[String(quantity)];
    if (!bundleVariantId) return null;

    const bundleLabels = config.bundleLabels || {};
    const props = {
      Bundle: 'Custom Bundle',
      'Bundle Size': String(quantity),
      'Bundle Label': bundleLabels[String(quantity)] || 'BadAss ' + quantity + '-Candle Bundle',
    };

    for (let i = 0; i < quantity; i += 1) {
      const scent = scents[i];
      props['Scent ' + (i + 1)] = scent && scent.title ? scent.title : 'Scent ' + (i + 1);
    }

    return {
      items: [{ id: parseInt(bundleVariantId, 10), quantity: 1, properties: props }],
    };
  }

  async function addBundleToCart(root, cartBody, options) {
    const opts = options || {};
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = Object.assign({}, cartBody);
    const sections = getCartSectionsPayload(cart);
    if (sections && sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(getAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (data.status) {
      throw new Error(data.description || data.message || 'Could not add bundle to cart.');
    }

    const variantId = cartBody.items && cartBody.items.length ? cartBody.items[0].id : null;
    if (opts.skipNotify) return data;

    if (!cart && !opts.redirectCheckout) {
      window.location = getRoutes().cart_url || '/cart';
      return data;
    }

    notifyCartAdded(data, variantId, {
      skipCartAddedModal: opts.skipCartAddedModal === true,
      bundleLabel: opts.bundleLabel || null,
    });
    return data;
  }

  function getBundlePayload(root, quantity, tile) {
    const config = getConfig(root);
    const productId = getProductId(root);
    const variantId = getSelectedVariantId(root);
    const discount = tile ? tile.getAttribute('data-discount') : null;
    const discountCode = tile ? tile.getAttribute('data-discount-code') : null;
    return {
      config: config,
      productId: productId || null,
      variantId: variantId || null,
      quantity: quantity,
      discount: discount != null && discount !== '' ? Number(discount) : null,
      tier: tierForQuantity(quantity, discount, discountCode),
    };
  }

  function buildSeedProduct(root) {
    const config = getConfig(root);
    const variantId = getSelectedVariantId(root);
    return {
      id: config.productId || getProductId(root) || null,
      title: config.productTitle || getProductTitle(root),
      handle: config.productHandle || '',
      featured_image: config.productImage || '',
      variant_id: variantId || config.variantId || null,
      available: config.productAvailable !== false,
      price: config.productPrice || 0,
      compare_at_price: config.productCompareAtPrice || config.productPrice || 0,
      tags: Array.isArray(config.productTags) ? config.productTags : [],
    };
  }

  function redirectToBundle(root, quantity, tile, options) {
    const opts = options || {};
    const payload = getBundlePayload(root, quantity, tile);
    payload.pickDifferentScents = opts.pickDifferentScents === true;
    if (payload.pickDifferentScents) {
      payload.seedProduct = buildSeedProduct(root);
    }
    storeBundleIntent(payload);
    const bundlePageUrl = payload.config.bundlePageUrl || '/pages/bundle';
    window.location.href = buildBundleUrl(bundlePageUrl, payload);
  }

  function getPickerEls() {
    const modal = document.getElementById('badass-pdp-scent-picker');
    if (!modal) return null;
    return {
      modal: modal,
      list: modal.querySelector('[data-pdp-scent-list]'),
      counter: modal.querySelector('[data-pdp-scent-counter]'),
      hint: modal.querySelector('[data-pdp-scent-hint]'),
      addBtn: modal.querySelector('[data-pdp-scent-add]'),
      checkoutBtn: modal.querySelector('[data-pdp-scent-checkout]'),
      filters: modal.querySelectorAll('[data-pdp-scent-filter]'),
    };
  }

  /* Keep modal on body so position:fixed centers to the viewport (not a transformed PDP ancestor). */
  function mountPickerToBody() {
    const modal = document.getElementById('badass-pdp-scent-picker');
    if (!modal || !document.body) return modal;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function productMatchesFilter(product, filter) {
    if (!filter || filter === 'all') return true;
    const tags = (product.tags || []).map((tag) => String(tag).toLowerCase());
    const haystack = tags.join(' | ');
    if (filter === 'new-arrivals') {
      return (
        haystack.indexOf('newly launched') >= 0 ||
        haystack.indexOf('new launch') >= 0 ||
        haystack.indexOf('new arrival') >= 0 ||
        tags.indexOf('new') >= 0
      );
    }
    if (
      filter === 'fallout scents' ||
      filter === 'fallout-scents' ||
      filter === 'fall scents' ||
      filter === 'fall scent'
    ) {
      return (
        haystack.indexOf('fallout scents') >= 0 ||
        haystack.indexOf('fallout scent') >= 0 ||
        haystack.indexOf('fall scents') >= 0 ||
        haystack.indexOf('fall scent') >= 0
      );
    }
    return haystack.indexOf(String(filter).toLowerCase()) >= 0;
  }

  function ensureProductInPool(product) {
    if (!product || product.id == null) return;
    const exists = pickerState.products.some((item) => String(item.id) === String(product.id));
    if (!exists) pickerState.products.unshift(product);
  }

  function countSelected() {
    return pickerState.selected.filter(Boolean).length;
  }

  function isProductSelected(productId) {
    return pickerState.selected.some((item) => item && String(item.id) === String(productId));
  }

  function updatePickerChrome() {
    const els = getPickerEls();
    if (!els) return;
    const filled = countSelected();
    const size = pickerState.quantity;
    if (els.counter) els.counter.textContent = filled + ' of ' + size + ' selected';
    const complete = filled >= size;
    if (els.hint) {
      els.hint.textContent = complete
        ? 'Ready — add to cart or checkout.'
        : 'Select ' + (size - filled) + ' more scent' + (size - filled === 1 ? '' : 's') + '.';
    }
    if (els.addBtn) els.addBtn.disabled = !complete;
    if (els.checkoutBtn) els.checkoutBtn.disabled = !complete;
  }

  function toggleProduct(product) {
    if (!product || !product.available) return;
    const id = String(product.id);
    const idx = pickerState.selected.findIndex((item) => item && String(item.id) === id);
    if (idx >= 0) {
      pickerState.selected[idx] = null;
      /* compact nulls to the end while keeping order of remaining */
      const kept = pickerState.selected.filter(Boolean);
      pickerState.selected = Array.from({ length: pickerState.quantity }, (_, i) => kept[i] || null);
    } else {
      if (countSelected() >= pickerState.quantity) return;
      const emptyIdx = pickerState.selected.findIndex((item) => !item);
      if (emptyIdx < 0) return;
      pickerState.selected[emptyIdx] = product;
    }
    renderPickerList();
    updatePickerChrome();
  }

  function renderPickerList() {
    const els = getPickerEls();
    if (!els || !els.list) return;
    const config = pickerState.root ? getConfig(pickerState.root) : {};
    const moneyFormat = config.moneyFormat;
    const filled = countSelected();
    const full = filled >= pickerState.quantity;

    let filtered = pickerState.products.filter((product) => productMatchesFilter(product, pickerState.filter));
    if (pickerState.filter === 'all') {
      filtered = filtered.slice().sort((a, b) => {
        const aNew = productMatchesFilter(a, 'new-arrivals') ? 1 : 0;
        const bNew = productMatchesFilter(b, 'new-arrivals') ? 1 : 0;
        return bNew - aNew;
      });
    }

    if (!filtered.length) {
      els.list.innerHTML = '<p class="badass-pdp-scent-picker__empty">No scents match this filter.</p>';
      return;
    }

    els.list.innerHTML = '';
    filtered.forEach((product) => {
      const selected = isProductSelected(product.id);
      const disabled = !product.available || (full && !selected);
      const card = document.createElement('button');
      card.type = 'button';
      card.className =
        'badass-pdp-scent-picker__card' +
        (selected ? ' is-selected' : '') +
        (!product.available ? ' is-soldout' : '');
      card.setAttribute('role', 'listitem');
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      card.disabled = disabled;

      const price = Number(product.price) || 0;
      const compare = Number(product.compare_at_price) || price;
      const priceHtml =
        compare > price
          ? '<span class="badass-pdp-scent-picker__compare">' +
            formatMoney(compare, moneyFormat) +
            '</span><span class="badass-pdp-scent-picker__price">' +
            formatMoney(price, moneyFormat) +
            '</span>'
          : '<span class="badass-pdp-scent-picker__price">' + formatMoney(price, moneyFormat) + '</span>';

      card.innerHTML =
        '<span class="badass-pdp-scent-picker__media">' +
        (product.featured_image
          ? '<img src="' +
            product.featured_image +
            '" alt="" loading="lazy" width="120" height="120">'
          : '') +
        '</span>' +
        '<span class="badass-pdp-scent-picker__meta">' +
        '<span class="badass-pdp-scent-picker__name">' +
        String(product.title || '').replace(/</g, '&lt;') +
        '</span>' +
        '<span class="badass-pdp-scent-picker__prices">' +
        priceHtml +
        '</span>' +
        '</span>' +
        (selected ? '<span class="badass-pdp-scent-picker__check" aria-hidden="true">✓</span>' : '');

      card.addEventListener('click', function () {
        toggleProduct(product);
      });
      els.list.appendChild(card);
    });
  }

  function setPickerFilter(filter) {
    pickerState.filter = filter || 'all';
    const els = getPickerEls();
    if (els) {
      els.filters.forEach((btn) => {
        const active = (btn.getAttribute('data-pdp-scent-filter') || '') === pickerState.filter;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    renderPickerList();
  }

  function closeScentPicker() {
    const els = getPickerEls();
    if (!els) return;
    els.modal.setAttribute('hidden', '');
    els.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (els.addBtn) els.addBtn.classList.remove('is-loading');
    if (els.checkoutBtn) els.checkoutBtn.classList.remove('is-loading');
  }

  function openScentPicker(root, quantity) {
    mountPickerToBody();
    const els = getPickerEls();
    if (!els) {
      redirectToBundle(root, quantity, null, { pickDifferentScents: true });
      return;
    }

    const config = getConfig(root);
    const seed = buildSeedProduct(root);
    const pool = Array.isArray(config.scentProducts) ? config.scentProducts.slice() : [];
    pickerState.root = root;
    pickerState.quantity = quantity;
    pickerState.products = pool;
    pickerState.filter = 'all';
    pickerState.selected = Array.from({ length: quantity }, () => null);
    ensureProductInPool(seed);
    if (seed && seed.available !== false) pickerState.selected[0] = seed;

    setPickerFilter('all');
    updatePickerChrome();
    els.modal.removeAttribute('hidden');
    els.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    bindPickerOnce();
  }

  async function submitPicker(redirectCheckout) {
    const els = getPickerEls();
    if (!pickerState.root || countSelected() < pickerState.quantity) return;

    const config = getConfig(pickerState.root);
    const scents = pickerState.selected.slice(0, pickerState.quantity);
    const cartBody = buildMixedScentCartBody(config, pickerState.quantity, scents);
    if (!cartBody) {
      showError(pickerState.root, 'Bundle product is not configured for this size.');
      return;
    }

    const activeBtn = redirectCheckout ? els && els.checkoutBtn : els && els.addBtn;
    if (activeBtn) activeBtn.classList.add('is-loading');
    if (els && els.addBtn) els.addBtn.disabled = true;
    if (els && els.checkoutBtn) els.checkoutBtn.disabled = true;

    try {
      const labels = config.bundleLabels || {};
      await addBundleToCart(pickerState.root, cartBody, {
        skipCartAddedModal: redirectCheckout === true,
        bundleLabel: labels[String(pickerState.quantity)] || null,
      });
      showError(pickerState.root, '');
      closeScentPicker();
      if (redirectCheckout) {
        window.location.href = getCheckoutUrl();
      }
    } catch (err) {
      showError(pickerState.root, err && err.message ? err.message : 'Could not add bundle to cart.');
      updatePickerChrome();
    } finally {
      if (activeBtn) activeBtn.classList.remove('is-loading');
    }
  }

  function bindPickerOnce() {
    if (pickerState.bound) return;
    const els = getPickerEls();
    if (!els) return;
    pickerState.bound = true;

    els.modal.querySelectorAll('[data-pdp-scent-close]').forEach((el) => {
      el.addEventListener('click', closeScentPicker);
    });

    els.filters.forEach((btn) => {
      btn.addEventListener('click', function () {
        setPickerFilter(btn.getAttribute('data-pdp-scent-filter') || 'all');
      });
    });

    if (els.addBtn) {
      els.addBtn.addEventListener('click', function () {
        submitPicker(false);
      });
    }
    if (els.checkoutBtn) {
      els.checkoutBtn.addEventListener('click', function () {
        submitPicker(true);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!els.modal || els.modal.hasAttribute('hidden')) return;
      closeScentPicker();
    });
  }

  function openBundleChoiceModal(root, quantity, tile) {
    const modalApi = window.BadassBundleQtyModal;
    if (!modalApi || typeof modalApi.open !== 'function') {
      openScentPicker(root, quantity);
      return;
    }

    const config = getConfig(root);
    const productTitle = getProductTitle(root);
    const cartBody = buildSameScentCartBody(config, quantity, productTitle);

    modalApi.open({
      mode: 'pdp',
      quantity: quantity,
      title: 'Add ' + quantity + '-candle bundle',
      text: 'Use the same scent for every candle, or pick different scents below.',
      onSame: async function () {
        if (!cartBody) {
          showError(root, 'Bundle product is not configured for this size.');
          return false;
        }
        try {
          await addBundleToCart(root, cartBody);
          showError(root, '');
          return true;
        } catch (err) {
          showError(root, err && err.message ? err.message : 'Could not add bundle to cart.');
          return false;
        }
      },
      onDifferent: function () {
        openScentPicker(root, quantity);
      },
    });
  }

  function syncHiddenQuantity(root, quantity) {
    const formWrap = root.closest('.product-form__quantity') || root.parentElement;
    const input = formWrap ? formWrap.querySelector('.quantity__input') : null;
    if (input) {
      input.value = String(Math.max(1, quantity));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function selectTile(root, tile) {
    root.querySelectorAll('[data-qty-offer]').forEach((btn) => {
      const selected = btn === tile;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  async function onTileClick(root, tile) {
    const quantity = parseInt(tile.getAttribute('data-quantity') || tile.getAttribute('data-qty'), 10) || 1;
    showError(root, '');
    selectTile(root, tile);
    syncHiddenQuantity(root, quantity === 1 ? 1 : quantity);

    if (quantity <= 1) {
      /* Landing / shop-now style: Buy 1 still opens scent picker */
      if (root.getAttribute('data-landing-open-picker') === 'true') {
        openScentPicker(root, 1);
      }
      return;
    }

    openBundleChoiceModal(root, quantity, tile);
  }

  function shouldShowBundleModal(quantity) {
    return Number(quantity) > 1;
  }

  function interceptProductFormSubmit(root) {
    /* Only intercept ATC on real PDPs — never document-wide (breaks other forms/links). */
    const scope = root.closest('product-info, .product');
    if (!scope) return;
    const productForm = scope.querySelector('product-form');
    if (!productForm || productForm.dataset.qtyOffersIntercept === 'true') return;
    productForm.dataset.qtyOffersIntercept = 'true';

    const form = productForm.querySelector('form');
    if (!form) return;

    function handleBundleSubmit(event) {
      const qtyInput = form.querySelector('[name="quantity"]');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!shouldShowBundleModal(quantity)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const selectedTile =
        root.querySelector('[data-qty-offer].is-selected') ||
        root.querySelector('[data-qty-offer][data-qty="' + quantity + '"]');
      openBundleChoiceModal(root, quantity, selectedTile);
    }

    form.addEventListener('submit', handleBundleSubmit, true);

    const buyNow = productForm.querySelector('[data-buy-now-button]');
    if (buyNow) {
      buyNow.addEventListener('click', handleBundleSubmit, true);
    }
  }

  function ensureIntercepts() {
    document.querySelectorAll('[data-badass-qty-offers]').forEach((root) => {
      interceptProductFormSubmit(root);
    });
  }

  document.addEventListener('click', (event) => {
    const tile = event.target && event.target.closest ? event.target.closest('[data-qty-offer]') : null;
    if (!tile) return;
    const root = getOffersRoot(tile);
    if (!root) return;
    event.preventDefault();
    onTileClick(root, tile);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const tile = event.target && event.target.closest ? event.target.closest('[data-qty-offer]') : null;
    if (!tile) return;
    const root = getOffersRoot(tile);
    if (!root) return;
    event.preventDefault();
    onTileClick(root, tile);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountPickerToBody();
      ensureIntercepts();
    });
  } else {
    mountPickerToBody();
    ensureIntercepts();
  }

  document.addEventListener('shopify:section:load', function () {
    mountPickerToBody();
    ensureIntercepts();
  });
  document.addEventListener('variant:change', ensureIntercepts);
})();
